import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { useFieldSettingDialog } from '@/presentation/pages/workspace-detail/modules/field-setting/use-field-setting-dialog';
export const ColumnManageServiceSymbol = Symbol.for('ColumnManageService');
let ColumnManageService = class ColumnManageService {
    constructor() {
        this._isDialogOpen = false;
    }
    initBridge() {
        if (this.bridge) {
            this.bridge = null;
        }
        this.bridge = useFieldSettingDialog();
    }
    get isDialogOpen() {
        return this._isDialogOpen;
    }
    open(title) {
        if (title) {
            this.dialogTitle = title;
        }
        else {
            this.dialogTitle = undefined;
        }
        this._isDialogOpen = true;
        return this.bridge?.openVisibleFieldSettingDialog()
            ?.finally(() => {
            this._isDialogOpen = false;
        });
    }
};
ColumnManageService = __decorate([
    injectable()
], ColumnManageService);
export { ColumnManageService };
